import { RouteObject } from "react-router-dom";
import { NotFound } from "src/routes/NotFound";
import { ProductOfferingCheckoutStartingConfigPage } from "src/routes/developments/product-offerings/ProductOfferingCheckoutStartingConfigPage";
import { ProductOfferingCostCalculatorPage } from "src/routes/developments/product-offerings/ProductOfferingCostCalculatorPage";
import { ProductOfferingScopePage } from "src/routes/developments/product-offerings/ProductOfferingScopePage";
import { ProductOfferingUwStartingConfigsPage } from "src/routes/developments/product-offerings/ProductOfferingUwStartingConfigsPage";
import { GlobalProductOfferings } from "src/routes/libraries/product-offerings/GlobalProductOfferings";
import { AddProductOfferingPage } from "src/routes/libraries/product-offerings/add-product-offering/AddProductOfferingPage";
import { CheckoutPricingTracePage } from "src/routes/libraries/product-offerings/checkout-pricing-trace/CheckoutPricingTracePage";
import { EditProductOfferingPage } from "src/routes/libraries/product-offerings/edit-product-offering/EditProductOfferingPage";
import { AppShell } from "src/routing/components/AppShell";
import { BeamNavbarLayout } from "src/routing/components/layouts/BeamNavbarLayout";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import { ScrollableParentLayout } from "src/routing/components/layouts/ScrollableParentLayout";
import * as productOfferingsPaths from "src/routing/domains/libraries/product-offerings/productOfferingsPaths";

/**
 * `/libraries/product-offerings/*` route tree.
 *
 * Role: data router domain route.
 *
 * Two layout stacks coexist during migration:
 * - **New (Beam):** `AppShell` → `BeamNavbarLayout` → page (index / cost calculator using `PageHeaderLayout`)
 * - **Legacy:** `AppShell` → `GlobalNavLayout` → `ScrollableParentLayout` → page (detail/wizard pages not yet on Beam nav)
 *
 * Some pages skip `ScrollableParentLayout` (e.g. scope uses its own side panel). Pages that have adopted
 * Beam's new layouts nest under the `BeamNavbarLayout` branch instead, which sits alongside `GlobalNavLayout`
 * under `AppShell`'s outlet — not under `GlobalNavLayout`, whose `PreventBrowserScroll` conflicts with the
 * document-scroll model those layouts assume.
 *
 * Path constants live in `productOfferingsPaths.ts`.
 */
export const productOfferingsRoute: RouteObject = {
  path: productOfferingsPaths.globalProductOfferingsRoute.path,
  Component: AppShell,
  children: [
    {
      Component: BeamNavbarLayout,
      children: [
        { index: true, Component: GlobalProductOfferings },
        {
          path: productOfferingsPaths.productOfferingCostCalculatorRoute.path,
          Component: ProductOfferingCostCalculatorPage,
        },
      ],
    },
    {
      Component: GlobalNavLayout,
      children: [
        // `ProductOfferingScopePage` uses its own internal layout to have a left side panel for filtering
        { path: productOfferingsPaths.productOfferingScopeRoute.path, Component: ProductOfferingScopePage },
        {
          Component: ScrollableParentLayout,
          children: [
            { path: productOfferingsPaths.productOfferingEditRoute.path, Component: EditProductOfferingPage },
            {
              path: productOfferingsPaths.productOfferingCheckoutStartingConfigRoute.path,
              Component: ProductOfferingCheckoutStartingConfigPage,
            },
            {
              path: productOfferingsPaths.productOfferingUwStartingConfigsRoute.path,
              Component: ProductOfferingUwStartingConfigsPage,
            },
            {
              path: productOfferingsPaths.productOfferingConfigPricingTraceRoute.path,
              Component: CheckoutPricingTracePage,
            },
            { path: productOfferingsPaths.productOfferingCreateRoute.path, Component: AddProductOfferingPage },
          ],
        },
      ],
    },
    { path: "*", Component: NotFound },
  ],
};
